<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page6-3')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg.text-center
              | ¿Qué le aconsejarías a Laura?
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Marca la respuesta correcta:
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;").mx-2.pr-5.parrafoDestacadoB(v-html="reactivo.descripcion")
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (response==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                          .pt-1.pr-2(v-if='sent && (response!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | Aunque podría ser un consejo prudente, en realidad no es necesario que Laura espere. 
                                |  Ella podría, por ejemplo, solicitar un Crédito Hipotecario para comprar el departamento 
                                |  y venderlo en un futuro. 
                                |  Después, podría usar ese dinero para: 
                                ul.pt-3
                                  li Liquidar el faltante de su deuda. 
                                  li Dar el enganche para una casa o un departamento más grande.
                                .pt-3  ¡Laura ha decidido contratar un Crédito Hipotecario, pero aún necesita tu ayuda!
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                b ¡Excelente consejo! 
                                .pt-3  Aunque un Crédito Hipotecario es un compromiso a largo plazo no significa 
                                  |  que Laura esté limitada a quedarse con ese departamento el resto de su vida. 
                                  |  Existen diversas opciones. Por ejemplo, podría vender el departamento en un futuro 
                                  |  y usar el dinero para:
                                ul.pt-3
                                  li Liquidar el faltante de su deuda. 
                                  li Dar el enganche para una casa o un departamento más grande. 
                                .pt-3   Laura ha tomado la mejor decisión, pero todavía necesita tu ayuda.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                | Siempre es buena idea tener una meta de ahorro y anticipar, pero 
                                |  ¿sabías que existen maneras de incrementar tu capacidad de pago? 
                                .pt-3  Además, si ella contrata el Crédito Hipotecario ahora, puede disfrutar 
                                  |  su departamento desde ya, ¡no tiene que esperar! 
                                .pt-3   ¡Laura ha decidido contratar un Crédito Hipotecario, pero aún necesita tu ayuda!
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage('page6-5')")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      reactivos: [{
          descripcion: '<b>Espera un poco.</b> Un Crédito Hipotecario es un compromiso a largo plazo y lo tienes que pensar muy bien. En unos años tendrás mayor capacidad de pago y podrás adquirir algo mucho mejor.',
        },
        {
          descripcion: '<b>¿Por qué no piensas en un Crédito Hipotecario? </b> Aunque parezca que aún eres muy joven para adquirir un compromiso así, ¡podrías sorprenderte!',
        },
        {
          descripcion: '<b>No te alcanzará, tu capacidad de pago es baja. </b> Es mucho mejor idea generar una meta de ahorro para comprarte el departamento en unos años.',
        }
      ],
      selected: [],
      respuesta: 'none',
      response: 0,
      correcta: 1,
      sent: false,
      feedback: false,
      dialog: false
    }
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.response);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    },
    checkResult() {
      return {
        'done': this.response != 'none',
        'clear': this.response == 'none'
      }
    }
  }
};
</script>
